import { LitElement, css, html } from 'lit';
import { customElement, property, query } from 'lit/decorators';

import { Dialog } from '@material/mwc-dialog';

@customElement('confirm-dialog')
export class ConfirmDialogElement extends LitElement {
    @query('#modal')
    private modal!: Dialog;

    @property({ type: String })
    header: string = 'Confirm?';

    open(state: boolean = true) {
        this.modal.open = state;
    }

    private confirm() {
        const onConfirm = new CustomEvent('on-confirm', {
            detail: {
                message: 'Confirm',
            },
        });
        this.dispatchEvent(onConfirm);

        this.modal.open = false;
    }

    render() {
        return html`
            <mwc-dialog id="modal" class="dialog" hideActions>
                <modal-dialog size="sm" @close="${() => this.open(false)}">
                    <div slot="body">
                        <div class="dialogTitle">
                            <div class="title">${this.header}</div>
                            <hr />
                        </div>
                        <div style="display:block">
                            <slot></slot>
                        </div>
                        <mwc-button class="button red" @click="${this.confirm}" raised
                            >CONFIRM</mwc-button
                        >
                    </div>
                </modal-dialog>
            </mwc-dialog>
        `;
    }

    static get styles() {
        return css`
            hr {
                border: 0;
                height: 1px;
                background: var(--theme-border-color);
            }

            .dialogTitle {
                display: block;
                position: sticky;
                top: 0px;
                z-index: 10;
            }

            .title {
                font-size: 1.2em;
                font-weight: 700;
                text-align: center;
                background-color: var(--theme-white-color);
            }

            .button {
                width: 100px;
                margin: 0px;
                margin-left: 10px;
                color: var(--theme-white-color);
            }

            .red {
                --mdc-theme-primary: var(--main-invalid-color);
                width: 150px;
            }
        `;
    }
}
